import { types as t, getParent } from 'mobx-state-tree';
import Variant from './Variant';

export default t.model("NewVariantItem", {
    //Properties: t.optional(t.frozen(), {}),//t.optional(PropertyItem, {}),
    GroupKey: t.maybeNull(t.string),
    GroupName: t.maybeNull(t.string),
    GroupUrlSlug: t.maybeNull(t.string),
    Images: t.optional(t.array(t.frozen()), []),
    Variants: t.array(Variant),
    SortOrder:t.optional(t.number, 0)
    
}).views(self => ({


})).actions(self => ({

}));